module.exports = __webpack_public_path__ + "media/images/baranka_down-7e31d81c.svg";